import { initDatadog } from '@/services/datadog/init';

initDatadog().catch(() => undefined);
